<template>
  <div class="height100">
    <div class="border">
      <v-row class="m-r-0 m-l-0">
        <span class="font-size-header css-audit-detail">API log</span>
      </v-row>
    </div>
    <div class="borderTop0 p-l-10 p-r-10">
      <div v-if="Object.keys(jsonObejct).length > 0">
        <json-viewer
          v-model="jsonObejct"
          :expand-depth="3"
          copyable
          boxed
          expanded
        ></json-viewer>
      </div>
      <pre v-else></pre>
    </div>

    <div class="tabs">
      <v-tabs centered fixed-tabs v-model="currentTab">
        <v-tab
          v-for="item in tabs"
          :id="item.toLowerCase()"
          :key="item"
          :value="item"
          class="font-size-sub"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import apiApiLog from '@/apis/api_log'

export default {
  props: {
    apiLogDetail: Object
  },
  data() {
    return {
      jsonObjectAll: {},
      jsonObejct: {},
      tabs: ['request', 'body', 'response'],
      // activeTab: 0,
      currentTab: 0
    }
  },
  watch: {
    'apiLogDetail.id': {
      immediate: true,
      handler(newValue) {
        this.jsonObejct = {}

        if (newValue) {
          this.getApiLogDetail()
        }
      }
    },
    currentTab: {
      handler(val) {
        this.jsonObejct = this.jsonObjectAll[this.tabs[val]] || {}
        this.apiLogDetail.currentTab = val
      }
    }
  },
  created() {},
  methods: {
    async getApiLogDetail() {
      try {
        const getApiLogDetail = await apiApiLog.getApiLogDetail(
          this.apiLogDetail.id
        )

        const obj = {}
        obj.request = getApiLogDetail.data.request || {}
        obj.body = getApiLogDetail.data.body || {}
        obj.response = getApiLogDetail.data.response || {}

        this.jsonObjectAll = obj

        setTimeout(() => {
          if (this.apiLogDetail.currentTab === -1) this.currentTab = 2

          this.jsonObejct =
            this.jsonObjectAll[this.tabs[this.apiLogDetail.currentTab]] || {}
        }, 100)
      } catch {}
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  background-color: #ebebeb;
  border: 1px solid;
  border-color: #ebebeb;
  padding: 5px;
}
.css-audit-detail {
  padding: 5px;
}

.borderTop0 {
  height: calc(100vh - 172px);
  max-height: calc(100vh - 172px);
  min-height: calc(100vh - 172px);
}

::v-deep .v-tabs--fixed-tabs .v-tab {
  width: auto;
}

::v-deep .v-slide-group {
  height: 40px !important;
}

::v-deep .v-slide-group__prev,
::v-deep .v-slide-group__next {
  display: none;
}

.tabs {
  margin-top: 2px;
}
</style>
